interface AppConfig {
  FINANCIAL_SETTINGS: {
    VAT_RATE: number;
  };
}

let config: AppConfig | null = null;

export const loadAppConfig = async (): Promise<AppConfig> => {
  if (config) return config;

  try {
    const response = await fetch('/appsettings.json');
    if (!response.ok) {
      throw new Error('Failed to load app settings');
    }
    config = await response.json();
    return config as AppConfig;
  } catch (error) {
    console.error('Error loading app settings:', error);
    // Fallback to default values
    config = {
      FINANCIAL_SETTINGS: {
        VAT_RATE: 18,
      },
    };
    return config;
  }
};

export const getAppConfig = (): AppConfig => {
  if (!config) {
    throw new Error('App config not loaded. Call loadAppConfig() first.');
  }
  return config;
};

export const getVatRate = (): number => {
  return getAppConfig().FINANCIAL_SETTINGS.VAT_RATE;
};
